import React, { Component, Fragment } from "react";
import clsx from "clsx";
import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  YAxis,
  XAxis,
  Cell,
} from "recharts";

import {
  CustomizedXAxisTick,
  StandardTooltip,
  selectFormat,
  Error,
  MAIN_COLORS,
} from "./../Utils/Utils.js";

class LeeSessionsBuckets extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: this.props.data.data,
    opts: {
      type: "other",
    },
  });

  render() {
    const { data, title } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={400} />;
    }

    // Enhance data to include color
    const enhancedData = data.data.map((entry, index) => ({
      ...entry,
      color: MAIN_COLORS[index % MAIN_COLORS.length],
    }));

    return (
      <ResponsiveContainer height={400}>
        <BarChart
          data={enhancedData}
          layout="vertical"
          margin={{ top: 10, right: 0, left: 5, bottom: 10 }}
        >
          <Tooltip
            cursor={{ fill: "#eee", opacity: 0.5 }}
            content={
              <StandardTooltip
                render={({ data }) => {
                  const payload = data(this.props);

                  if (payload !== null) {
                    return (
                      <div className="standard-tooltip">
                        {Object.keys(payload).map((key) => (
                          <Fragment key={key}>
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                {title}
                              </span>
                              <span className="standard-tooltip__value-heade">
                                {payload[key].payload.name}
                              </span>
                            </header>
                            <main className="standard-tooltip__main">
                              {Object.keys(payload)
                                .sort(
                                  (a, b) => payload[b].value - payload[a].value
                                )
                                .map((key, index) => (
                                  <div
                                    className="standard-tooltip__item"
                                    key={key}
                                  >
                                    <span
                                      className="standard-tooltip__icon"
                                      style={{
                                        background: payload[key].payload.color,
                                      }}
                                    />
                                    <span
                                      className={clsx(
                                        "standard-tooltip__key",
                                        "text-capitalize"
                                      )}
                                      style={{
                                        color: payload[key].payload.color,
                                      }}
                                    >
                                      {payload[index].payload.bucket ||
                                        payload[key].dataKey}
                                    </span>
                                    <span className="standard-tooltip__value">
                                      {selectFormat(
                                        "number",
                                        payload[key].value
                                      )}
                                    </span>
                                  </div>
                                ))}
                            </main>
                          </Fragment>
                        ))}
                      </div>
                    );
                  }
                }}
              />
            }
          />
          <XAxis
            type="number"
            axisLine={false}
            tickLine={false}
            mirror={false}
            dataKey="value"
            tick={<CustomizedXAxisTick />}
          />
          <YAxis
            type="category"
            axisLine={false}
            tickLine={false}
            mirror={false}
            dataKey="bucket"
          />
          <Bar dataKey="value">
            {enhancedData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default LeeSessionsBuckets;
